// hooks
import useSwitch from 'hooks/useSwitch';
import useInput from 'hooks/useInput';
import { useMetamask } from 'contexts/Metamask';

// libraries
import clsx from 'clsx';
import { toast } from 'react-toastify';

// components
import Button from 'components/Button';
import classes from './Blacklist.module.scss';
import Contracts from 'helpers/contracts';

export default function Blacklist() {
  const { account, isConnectedToAllowedNetwork, handleTransactionError } = useMetamask();
  const blacklistWalletAddress = useInput();
  const isBlacklisted = useSwitch(true);
  const isTransactionInProgress = useSwitch();

  const onWalletAddressChange = async (e: any) => {
    blacklistWalletAddress.set(e);
    const contract = Contracts.instances;
    const callableIsBlacklisted = contract.Blacklist.methods.blackListed(e.target.value);
    try {
      const isBlacklistedResponse = await callableIsBlacklisted.call();
      isBlacklisted.set(isBlacklistedResponse);
    } catch (err) {
      console.log(err);
    }
  };

  const blacklist = async () => {
    if (!(await isConnectedToAllowedNetwork())) return;
    if (!blacklistWalletAddress.value) return toast.error('Please enter a wallet address');

    try {
      isTransactionInProgress.true();
      const { Blacklist } = Contracts.instances;
      let callable = Blacklist.methods.addToBlackList(blacklistWalletAddress.value)
      if(!isBlacklisted.value){ // don't blacklist
        callable = Blacklist.methods.removeFromBlackList(blacklistWalletAddress.value)
      }
      await callable.send({ from: account });
      toast.success('User added to Blacklist');
    } catch (err) {
      handleTransactionError(err);
    }

    isTransactionInProgress.false();
  };

  return (
    <div className={classes.block}>
      <table>
        <tbody>
          <tr className={classes.inputRow}>
            <td className={classes.label}>Wallet Address</td>
            <td>
              <input
                onChange={onWalletAddressChange}
                className={classes.input}
                disabled={isTransactionInProgress.value}
              />
            </td>
          </tr>
          <tr className={clsx(classes.inputRow, classes.isActiveAdmin)}>
            <td className={classes.label}>Blacklist User?</td>
            <td>
              <button
                onClick={isBlacklisted.toggle}
                className={clsx(classes.isAdminButton, {
                  [classes.green]: isBlacklisted.value,
                  [classes.red]: !isBlacklisted.value,
                })}>
                <span className={classes.isAdminButtonText}>{isBlacklisted.value ? 'True' : 'False'}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <Button
        text="Blacklist"
        onClick={blacklist}
        className={classes.button}
        loading={isTransactionInProgress.value}
      />
    </div>
  );
}
